import React, { useEffect, useRef, useState } from 'react'
import TextButton from 'components/Luxkit/Button/TextButton'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'components/Luxkit/Typography/BodyText'
import TextLink from 'components/Luxkit/TextLink'
import VerticalSpacer from '../Spacing/VerticalSpacer'
import { groupBy } from 'lib/array/arrayUtils'
import { objectEntries } from 'lib/object/objectUtils'

const DestinationItemsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: ${rem(30)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(4, 1fr);
  }
`

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem(40)};

  ${mediaQueryUp.tablet} {
    align-items: center;
    margin-top: ${rem(24)};
  }
`

interface Props {
  linkBoxes: Array<App.ContentLinkBox> | null
  maxDefaultHeight: number
}

function LinkBox({ linkBoxes, maxDefaultHeight }: Props) {
  const containerRef = useRef<HTMLDivElement>(null)
  const [isOpenAllLinks, setOpenAllLinks] = useState(false)
  const [containerMaxHeight, setContainerMaxHeight] = useState(maxDefaultHeight)
  const haveMoreToShow = containerMaxHeight < (containerRef.current?.scrollHeight || 0)

  useEffect(() => {
    if (!linkBoxes || !containerRef.current) return

    const fullHeight = containerRef.current.scrollHeight

    if (fullHeight > maxDefaultHeight) {
      setContainerMaxHeight(isOpenAllLinks ? fullHeight : maxDefaultHeight)
    }
  }, [linkBoxes, maxDefaultHeight, isOpenAllLinks])

  if (!linkBoxes) return null

  const displayGroups = groupBy(linkBoxes, link => link.subtitle ?? '')
  return (
    <>
      <DestinationItemsContainer ref={containerRef} style={{ maxHeight: `${containerMaxHeight}px`, overflow: 'hidden' }}>
        {objectEntries(displayGroups).map(([subtitle, group]) => {
          return (<VerticalSpacer gap={8} key={subtitle}>
            <BodyText colour="neutral-one" variant="medium" weight="bold">{subtitle}</BodyText>
            {group.map((link) => <VerticalSpacer gap={8} key={link.name}><TextLink
              key={link.url}
              size="small"
              variant="black"
              weight="regular"
              to={link.url}
            >
              {link.name}
            </TextLink>
            </VerticalSpacer>)}

          </VerticalSpacer>)
        })
      }
      </DestinationItemsContainer>
      { haveMoreToShow && <ButtonWrapper>
        <TextButton
          onClick={() => setOpenAllLinks(!isOpenAllLinks)}
          kind="secondary"
          size="large"
        >
          {isOpenAllLinks ?
            'Show less' :
            'Show all'
          }
        </TextButton>
      </ButtonWrapper>
    }
    </>
  )
}

export default LinkBox
